module.exports = __webpack_public_path__ + "dacf20a734f060de3ec851114d57157d.png";